import {toArray} from "../../helpers/strings";
import { toBool, getConfigValue } from "../../reducers/configReducer";
import { PURCHASE_RESTRICTIONS } from "../../config/const";

export const DEFAULT_PURCHASE_LIMITS = {};

export const getCurrentPurchaseLimits = (state) => {
  let masterCalculatorTicket = state.summary.summary;
  if (masterCalculatorTicket) {
    return getPurchaseLimits(masterCalculatorTicket);
  }
  return DEFAULT_PURCHASE_LIMITS;
};

export const getPurchaseLimits = (masterCalculatorTicket) => {
  if (masterCalculatorTicket && masterCalculatorTicket.usageLimitInfo){
    return masterCalculatorTicket.usageLimitInfo;
  }
  return DEFAULT_PURCHASE_LIMITS;
};

export const getCurrentLimitList = (state) => {
  return toLimitList(getCurrentPurchaseLimits(state));
}

export const toLimitList = (limits) => {
  return toArray(limits);
};

export const checkCurrentPurchaseLimits = (state) => {
  const currentLimitList = getCurrentLimitList(state);
  let limitsEnabled = toBool(getConfigValue(PURCHASE_RESTRICTIONS, state));
  if (!limitsEnabled) return true;

  return allLetPay(currentLimitList)
};

export const checkPurchaseLimits = (masterCalculatorTicket, state) => {
 let limitsEnabled = toBool(getConfigValue(PURCHASE_RESTRICTIONS, state));
 if (limitsEnabled){
   let limits = getPurchaseLimits(masterCalculatorTicket);
   return allLetPay(limits)
 }

 return true;
};

export const allLetPay = (limitList) => {
  return toLimitList(limitList).every(l => l.letPay);
};


// WEBPACK FOOTER //
// ./src/selectors/purchase_limits/purchase_limits_selectors.js